class Stream {
  constructor () {
    this._promise = Promise.resolve()
    this._isFree = true
  }
  get isFree () {
    return this._isFree
  }
  execute (executor, cb) {
    this._isFree = false
    this._promise = Promise
      .resolve()
      .then(() => {
        return executor()
      })
      .finally(() => {
        this._isFree = true
        cb(executor)
      })
  }
}

class AsyncStreams {
  constructor ({ count = 2 } = {}) {
    this._count = count
    this._register = new Map()
    this._streams = AsyncStreams.createStreams(this._count)
  }
  run (asyncCallback) {
    this._addToRegister(asyncCallback)
    this._run()
  }
  _run () {
    const freeStream = this._streams.find((stream) => {
      return stream.isFree
    })

    if (freeStream) {
      this._executorStream(freeStream)
    }
  }
  _executorStream (stream) {
    const executor = this._getNextAsyncCallback()

    const endCallback = () => {
      this._run()
    }

    if (executor) {
      this._removeFromRegister(executor)
      stream.execute(executor, endCallback)
    }
  }
  _addToRegister (asyncCallback) {
    this._register.set(asyncCallback, asyncCallback)
  }
  _removeFromRegister (asyncCallback) {
    this._register.delete(asyncCallback)
  }
  _getNextAsyncCallback () {
    const key = [...this._register.keys()][0]
    if (key) {
      return this._register.get(key)
    } else {
      return null
    }
  }
  static createStreams (steamCount) {
    const streams = Array(steamCount).fill(null)
    return streams.map(() => {
      return new Stream()
    })
  }
}

export default AsyncStreams
